export default function chunks<T>(array: T[], chunkSize: number): T[][] {
  const chunkedArray: T[][] = [];

  for (let index = 0; index < array.length; index += chunkSize) {
    chunkedArray.push(array.slice(index, index + chunkSize));
  }

  return chunkedArray;
}
